import React from "react";

const TimeToRead = ({ minutes }) => (
    <p className="readingTime">{minutes} minute{minutes > 1?'s':''} read.</p>
  )
export default TimeToRead